import 'babel-polyfill'
import promise from 'es6-promise'
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuescroll from "vuescroll/dist/vuescroll-native";
import "./assets/css/reset.css";
import "element-ui/lib/theme-chalk/index.css";
import "vuescroll/dist/vuescroll.css";
import Cookies from "js-cookie";
import Element from "element-ui";
import "./filters/index"
import VueLazyLoad from 'vue-lazyload'
import VueLazyLoadVideo from 'vue-lazyload-video'

promise.polyfill()


Vue.use(VueLazyLoadVideo)
Vue.use(VueLazyLoad, {
    error: './assets/images/index/default.png',
    loading: './assets/images/index/default.png'
})

Vue.use(vuescroll);

Vue.config.productionTip = false;
Vue.use(Element, {
    size: Cookies.get("fontsize") || "16" // set element-ui default size
});
new Vue({
    router,
    store,
    render: h => h(App),
    mounted() {
      // document.dispatchEvent(new Event('render-event'))
        document.dispatchEvent(new Event('custom-render-trigger'))
    }
}).$mount("#app");
router.beforeEach((to, from, next) => {
    let user = JSON.parse(window.sessionStorage.getItem('user')) || {userName: false};
    next();
})